import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/diff.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm diff [...<paths>]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/diff.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`Similar to its `}<inlineCode parentName="p">{`git diff`}</inlineCode>{` counterpart, this command will print diff patches
of files for packages published to the npm registry.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm diff --diff=<spec-a> --diff=<spec-b>`}</inlineCode></p>
        <p parentName="li">{`  Compares two package versions using their registry specifiers, e.g:
`}<inlineCode parentName="p">{`npm diff --diff=pkg@1.0.0 --diff=pkg@^2.0.0`}</inlineCode>{`. It's also possible to
compare across forks of any package,
e.g: `}<inlineCode parentName="p">{`npm diff --diff=pkg@1.0.0 --diff=pkg-fork@1.0.0`}</inlineCode>{`.`}</p>
        <p parentName="li">{`  Any valid spec can be used, so that it's also possible to compare
directories or git repositories,
e.g: `}<inlineCode parentName="p">{`npm diff --diff=pkg@latest --diff=./packages/pkg`}</inlineCode></p>
        <p parentName="li">{`  Here's an example comparing two different versions of a package named
`}<inlineCode parentName="p">{`abbrev`}</inlineCode>{` from the registry:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm diff --diff=abbrev@1.1.0 --diff=abbrev@1.1.1
`}</code></pre>
        <p parentName="li">{`  On success, output looks like:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`diff --git a/package.json b/package.json
index v1.1.0..v1.1.1 100644
--- a/package.json
+++ b/package.json
@@ -1,6 +1,6 @@
 {
   "name": "abbrev",
-  "version": "1.1.0",
+  "version": "1.1.1",
   "description": "Like ruby's abbrev module, but in js",
   "author": "Isaac Z. Schlueter <i@izs.me>",
   "main": "abbrev.js",
`}</code></pre>
        <p parentName="li">{`  Given the flexible nature of npm specs, you can also target local
directories or git repos just like when using `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm diff --diff=https://github.com/npm/libnpmdiff --diff=./local-path
`}</code></pre>
        <p parentName="li">{`  In the example above we can compare the contents from the package installed
from the git repo at `}<inlineCode parentName="p">{`github.com/npm/libnpmdiff`}</inlineCode>{` with the contents of the
`}<inlineCode parentName="p">{`./local-path`}</inlineCode>{` that contains a valid package, such as a modified copy of
the original.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm diff`}</inlineCode>{` (in a package directory, no arguments):`}</p>
        <p parentName="li">{`  If the package is published to the registry, `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{` will fetch the
tarball version tagged as `}<inlineCode parentName="p">{`latest`}</inlineCode>{` (this value can be configured using the
`}<inlineCode parentName="p">{`tag`}</inlineCode>{` option) and proceed to compare the contents of files present in that
tarball, with the current files in your local file system.`}</p>
        <p parentName="li">{`  This workflow provides a handy way for package authors to see what
package-tracked files have been changed in comparison with the latest
published version of that package.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm diff --diff=<pkg-name>`}</inlineCode>{` (in a package directory):`}</p>
        <p parentName="li">{`  When using a single package name (with no version or tag specifier) as an
argument, `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{` will work in a similar way to
`}<a parentName="p" {...{
            "href": "npm-outdated"
          }}><inlineCode parentName="a">{`npm-outdated`}</inlineCode></a>{` and reach for the registry to figure out
what current published version of the package named `}<inlineCode parentName="p">{`<pkg-name>`}</inlineCode>{`
will satisfy its dependent declared semver-range. Once that specific
version is known `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{` will print diff patches comparing the
current version of `}<inlineCode parentName="p">{`<pkg-name>`}</inlineCode>{` found in the local file system with
that specific version returned by the registry.`}</p>
        <p parentName="li">{`  Given a package named `}<inlineCode parentName="p">{`abbrev`}</inlineCode>{` that is currently installed:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm diff --diff=abbrev
`}</code></pre>
        <p parentName="li">{`  That will request from the registry its most up to date version and
will print a diff output comparing the currently installed version to this
newer one if the version numbers are not the same.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm diff --diff=<spec-a>`}</inlineCode>{` (in a package directory):`}</p>
        <p parentName="li">{`  Similar to using only a single package name, it's also possible to declare
a full registry specifier version if you wish to compare the local version
of an installed package with the specific version/tag/semver-range provided
in `}<inlineCode parentName="p">{`<spec-a>`}</inlineCode>{`.`}</p>
        <p parentName="li">{`  An example: assuming `}<inlineCode parentName="p">{`pkg@1.0.0`}</inlineCode>{` is installed in the current `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{`
folder, running:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm diff --diff=pkg@2.0.0
`}</code></pre>
        <p parentName="li">{`  It will effectively be an alias to
`}<inlineCode parentName="p">{`npm diff --diff=pkg@1.0.0 --diff=pkg@2.0.0`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm diff --diff=<semver-a> [--diff=<semver-b>]`}</inlineCode>{` (in a package directory):`}</p>
        <p parentName="li">{`  Using `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{` along with semver-valid version numbers is a shorthand
to compare different versions of the current package.`}</p>
        <p parentName="li">{`  It needs to be run from a package directory, such that for a package named
`}<inlineCode parentName="p">{`pkg`}</inlineCode>{` running `}<inlineCode parentName="p">{`npm diff --diff=1.0.0 --diff=1.0.1`}</inlineCode>{` is the same as running
`}<inlineCode parentName="p">{`npm diff --diff=pkg@1.0.0 --diff=pkg@1.0.1`}</inlineCode>{`.`}</p>
        <p parentName="li">{`  If only a single argument `}<inlineCode parentName="p">{`<version-a>`}</inlineCode>{` is provided, then the current local
file system is going to be compared against that version.`}</p>
        <p parentName="li">{`  Here's an example comparing two specific versions (published to the
configured registry) of the current project directory:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm diff --diff=1.0.0 --diff=1.1.0
`}</code></pre>
      </li>
    </ul>
    <p>{`Note that tag names are not valid `}<inlineCode parentName="p">{`--diff`}</inlineCode>{` argument values, if you wish to
compare to a published tag, you must use the `}<inlineCode parentName="p">{`pkg@tagname`}</inlineCode>{` syntax.`}</p>
    <h4>{`Filtering files`}</h4>
    <p>{`It's possible to also specify positional arguments using file names or globs
pattern matching in order to limit the result of diff patches to only a subset
of files for a given package, e.g:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm diff --diff=pkg@2 ./lib/ CHANGELOG.md
`}</code></pre>
    <p>{`In the example above the diff output is only going to print contents of files
located within the folder `}<inlineCode parentName="p">{`./lib/`}</inlineCode>{` and changed lines of code within the
`}<inlineCode parentName="p">{`CHANGELOG.md`}</inlineCode>{` file.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`diff`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Define arguments to compare in `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`diff-name-only`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Prints only filenames when using `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`diff-unified`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: 3`}</li>
      <li parentName="ul">{`Type: Number`}</li>
    </ul>
    <p>{`The number of lines of context to print in `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`diff-ignore-all-space`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Ignore whitespace when comparing lines in `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`diff-no-prefix`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Do not show any source or destination prefix in `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{` output.`}</p>
    <p>{`Note: this causes `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{` to ignore the `}<inlineCode parentName="p">{`--diff-src-prefix`}</inlineCode>{` and
`}<inlineCode parentName="p">{`--diff-dst-prefix`}</inlineCode>{` configs.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`diff-src-prefix`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "a/"`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`Source prefix to be used in `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{` output.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`diff-dst-prefix`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "b/"`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`Destination prefix to be used in `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{` output.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`diff-text`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Treat all files as text in `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`global`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Operates in "global" mode, so that packages are installed into the `}<inlineCode parentName="p">{`prefix`}</inlineCode>{`
folder instead of the current working directory. See
`}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/folders"
      }}>{`folders`}</a>{` for more on the differences in behavior.`}</p>
    <ul>
      <li parentName="ul">{`packages are installed into the `}<inlineCode parentName="li">{`{prefix}/lib/node_modules`}</inlineCode>{` folder, instead
of the current working directory.`}</li>
      <li parentName="ul">{`bin files are linked to `}<inlineCode parentName="li">{`{prefix}/bin`}</inlineCode></li>
      <li parentName="ul">{`man pages are linked to `}<inlineCode parentName="li">{`{prefix}/share/man`}</inlineCode></li>
    </ul>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`tag`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "latest"`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`If you ask npm to install a package and don't tell it a specific version,
then it will install the specified tag.`}</p>
    <p>{`Also the tag that is added to the package@version specified by the `}<inlineCode parentName="p">{`npm tag`}</inlineCode>{`
command, if no explicit tag is given.`}</p>
    <p>{`When used by the `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{` command, this is the tag used to fetch the
tarball that will be compared with the local files by default.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h2>{`See Also`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-outdated"
        }}>{`npm outdated`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      